import { render, staticRenderFns } from "./buyCardHome.vue?vue&type=template&id=1ae9a6ee&scoped=true&"
import script from "./buyCardHome.vue?vue&type=script&lang=js&"
export * from "./buyCardHome.vue?vue&type=script&lang=js&"
import style0 from "./buyCardHome.vue?vue&type=style&index=0&id=1ae9a6ee&lang=less&scoped=true&"
import style1 from "./buyCardHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9a6ee",
  null
  
)

export default component.exports